export default "__VITE_ASSET__HFiMkTOe__"